'use client';

import type { ReactNode } from 'react';
import AutoHeight from 'embla-carousel-auto-height';
import useCarousel from 'hooks/useCarousel';
import AutoPlayCarousel from 'components/shared/Carousel/AutoPlayCarousel';
import CarouselContent from 'components/shared/Carousel/CarouselContent';
import CarouselFooter from 'components/shared/Carousel/CarouselFooter';
import { OverflowVisibleSettings } from 'types/constants';

interface MediaCopyCarouselProps {
  children: ReactNode;
  totalItems: number;
}

export const MediaCopyCarousel = ({ children, totalItems }: MediaCopyCarouselProps) => {
  const { current, setApi, scrollTo } = useCarousel();

  return (
    <AutoPlayCarousel
      className="flex flex-col gap-8 md:gap-[50px]"
      setApi={setApi}
      plugins={[AutoHeight()]}
      opts={{ align: 'start', slidesToScroll: 1, containScroll: false, watchDrag: totalItems > 1 }}
      playOnInit={true}
      delay={5000}
      data-testid="media-copy-carousel">
      <CarouselContent className="w-full" overflowVisible={OverflowVisibleSettings.None}>
        <div className="flex space-x-8">{children}</div>
      </CarouselContent>
      <CarouselFooter
        totalItems={totalItems}
        current={current}
        scrollTo={scrollTo}
        className="flex sm:justify-start"
        isTimed={true}
        timeDuration={5}
      />
    </AutoPlayCarousel>
  );
};
